let isIosCache: any = null; //default true

export function isNumber(val: any) {
  const regPos = /^\d+(\.\d+)?$/; //非负浮点数
  const regNeg = /^(-(([0-9]+\.[0-9]*[1-9][0-9]*)|([0-9]*[1-9][0-9]*\.[0-9]+)|([0-9]*[1-9][0-9]*)))$/; //负浮点数
  if (regPos.test(val) || regNeg.test(val)) {
    return true;
  } else {
    return false;
  }
}

export const parsePrice = (string: string) => {
  const value = string.match(/\d+(?:\.\d+)?/g);
  if (value) {
    return value[0];
  }
  return "";
};

/**
 * 判断是否为JSON 字符串
 * @param str
 */
export function isJSON(str: string) {
  if (typeof str === "string") {
    try {
      const obj = JSON.parse(str);
      if (typeof obj === "object" && obj) {
        return true;
      } else {
        return false;
      }
    } catch (e) {
      return false;
    }
  }
}

export function getTimeZone() {
  try {
    const timezoneNum = -(new Date().getTimezoneOffset() / 60);
    const timezoneStr = timezoneNum.toString();
    let timezoneResult: string;
    if (timezoneNum > 9 || timezoneNum < -9) {
      if (timezoneStr.length > 2) {
        timezoneResult = timezoneStr + "00";
      } else {
        timezoneResult = "+" + timezoneStr + "00";
      }
    } else {
      const arr = timezoneStr.split("");
      if (timezoneStr.length > 1) {
        timezoneResult = arr[0] + "0" + arr[1] + "00";
      } else {
        timezoneResult = "+0" + timezoneStr + "00";
      }
    }
    return timezoneResult;
  } catch (error) {
    return "+0800";
  }
}

export function getLang() {
  return (
    window.navigator.language ||
    (window.navigator as any).userLanguage ||
    "en_US"
  );
}

export function isIpad() {
  if (
    window.navigator.userAgent &&
    window.navigator.userAgent.toLowerCase().indexOf("ipad") > -1
  ) {
    return "y";
  } else {
    return "n";
  }
}

export function isLength(value: any) {
  return typeof value === "number" && value > -1 && value % 1 === 0;
}

export function isArrayLike(value: any) {
  return value != null && isLength(value.length);
}

export function isEmpty(value: any) {
  if (value === null || value === undefined) {
    return true;
  }
  if (
    (isArrayLike(value) && typeof value === "string") ||
    typeof value.splice === "function" ||
    Array.isArray(value)
  ) {
    return !value.length;
  }
  for (const key in value) {
    if (Object.prototype.hasOwnProperty.call(value, key)) {
      return false;
    }
  }
  return true;
}

export function trimAll(str: string) {
  return str.replace(/\s+/g, "");
}

export function isEmail(str: string) {
  const re = /^\w+((-\w+)|(\.\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]+$/;
  if (re.test(str) !== true) {
    return false;
  } else {
    return true;
  }
}

/**
 * 换取当前的时间戳
 */
export function getNowTimeStamp() {
  return new Date().valueOf();
}

//时间戳的差值
export function diffTimeStamp(now: number, old: number) {
  if (now >= old) {
    return now - old;
  } else {
    return old - now;
  }
}

export function timestampToTime(timestamp: number) {
  const date = new Date(
    timestamp.toString().length === 10 ? timestamp * 1000 : timestamp
  ); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
  const addZero = (number: any) => {
    return number < 10 ? "0" + number : number;
  };
  const Y = date.getFullYear() + "-";
  const M =
    (date.getMonth() + 1 < 10
      ? "0" + (date.getMonth() + 1)
      : date.getMonth() + 1) + "-";
  const D = addZero(date.getDate()) + " ";
  const h = addZero(date.getHours()) + ":";
  const m = addZero(date.getMinutes()) + ":";
  const s = addZero(date.getSeconds());
  return Y + M + D + h + m + s;
}

export function timeToString(time: any) {
  const h =
    Math.floor(time / 3600) < 10
      ? "0" + Math.floor(time / 3600)
      : Math.floor(time / 3600);
  const m =
    Math.floor((time / 60) % 60) < 10
      ? "0" + Math.floor((time / 60) % 60)
      : Math.floor((time / 60) % 60);
  const s =
    Math.floor(time % 60) < 10
      ? "0" + Math.floor(time % 60)
      : Math.floor(time % 60);
  return (time = h + ":" + m + ":" + s);
}

export function isIos() {
  if (isIosCache !== null) {
    return isIosCache;
  } else {
    const u = window.navigator.userAgent;
    const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    isIosCache = isiOS;
    return isiOS;
  }
}

export function getAppVersion() {
  /**
   *  IOS 的UA无法获取到版本的字段，原生有BUG
   */
  try {
    let findName: string = "Hybrid";
    if (isIos()) {
      findName = "Hybird"; //钦振写的鸟人，hybrid都能拼错
    }
    const u = window.navigator.userAgent;
    const firstIndex = u.indexOf(findName);
    if (firstIndex === -1 || firstIndex === undefined) {
      //证明UA有问题:
      return "1.0.0";
    }
    const startIndex = u.indexOf("(", firstIndex);
    const endIndex = u.indexOf(")", startIndex);
    const fitlerString = u.substring(startIndex + 1, endIndex);
    return fitlerString.split(",")[0];
  } catch (error) {
    return "1.0.0";
  }
}

export function stringOccurrence(main_str: string, sub_str: string) {
  main_str += "";
  sub_str += "";

  if (sub_str.length <= 0) {
    return main_str.length + 1;
  }

  const subStr = sub_str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  return (main_str.match(new RegExp(subStr, "gi")) || []).length;
}

export function getElementOffset(el: Element) {
  const rect = el.getBoundingClientRect();
  return {
    x: rect.left + window.scrollX,
    y: rect.top + window.scrollY
  };
}
